function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ((useActualHostSelector ? ":host {" : hostSelector + " {")) + "display: contents;}ax-marketplace-header" + shadowSelector + " {position: relative;z-index: 100;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet];